import React from 'react';

interface ButtonProps{
    className?: string
    loading?: boolean
    saved?: boolean
    title?: string
    type?: 'submit' | 'button'
    disabled?: boolean
    children?: React.ReactNode
    onClick:(e?:any)=>void,

}
export default function Button(props: ButtonProps){
    const cls = "btn "+props.className;
    const {loading, saved, title} = props;
    const btnProps = {...props};
    delete btnProps.loading;
    delete btnProps.saved
    return (
        <button {...btnProps} disabled={props.disabled || loading || saved} className={cls}>
            {
                loading &&  <span className="loading loading-spinner" role="status" aria-hidden="true"/>
            }
            {!loading && !saved && props.children }
            {
                saved && <span>Saved</span>
            }
            {
                title && <span>{title}</span>
            }
        </button>
    )
}
